import React from 'react';
import AppRouter from './routes/AppRouter';


function AppPortfolio() {
  return (
    <div className="App">
      <AppRouter />
    </div>
  );
}

export default AppPortfolio;
